import React from 'react'
import { bestServices } from '../../utility/bestServices'
import { Fade } from 'react-awesome-reveal'
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import { Pagination, Autoplay } from "swiper/modules"

function BestServices() {
    return (
        <section className="section-services padding-tb-100 bg-market">
            <div className="container">
                <div className="row">
                    <Fade triggerOnce duration={1000} direction='up' className="col-lg-6 col-sm-12">
                        <>
                            <div className="zx-app-banner">
                                <h4>Best Services</h4>
                                <h2>Zorox Great Features You Must Enjoy With AI.</h2>
                            </div>
                            <div className="container-fulid">
                                <div className="row">
                                    {
                                        bestServices.map((data, index) => (
                                            <div key={index} className="col-md-6 col-sm-12 zx-app-zorox">
                                                <div className="zx-app-accouts">
                                                    <h5>{data.number}</h5>
                                                    <h4>{data.title}</h4>
                                                    <p>
                                                        {data.discription}
                                                    </p>
                                                </div>
                                            </div>
                                        ))
                                    }

                                </div>
                            </div>
                        </>
                    </Fade>
                    <Fade triggerOnce duration={1500} direction='up' className="col-lg-6 col-sm-12">
                        <Swiper
                            pagination={{
                                clickable: true
                            }}
                            modules={[Pagination, Autoplay]}
                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                            }}
                            loop={Infinity}

                            spaceBetween={50}
                            slidesPerView={1}
                            className="swiper p-10 lp-swip-services"
                        >

                            <div className="swiper-wrapper">
                                <SwiperSlide className="swiper-slide">
                                    <img src="assets/img/landing/1.png" alt="mobaile-viwe" className="mobaile-viwe" />
                                </SwiperSlide>
                                <SwiperSlide className="swiper-slide">
                                    <img src="assets/img/landing/2.png" alt="mobaile-viwe" className="mobaile-viwe" />
                                </SwiperSlide>
                                <SwiperSlide className="swiper-slide">
                                    <img src="assets/img/landing/3.png" alt="mobaile-viwe" className="mobaile-viwe" />
                                </SwiperSlide>
                            </div>
                            <div className="pagipagination-services">
                                <div className="swiper-pagination"></div>
                            </div>
                        </Swiper>
                    </Fade>
                </div>
            </div>
        </section>
    )
}

export default BestServices
